module.exports = __webpack_public_path__ + "static/img/9.ecc9836.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/9.png
// module id = ULPZ
// module chunks = 0